import isConfigEnabled from './isConfigEnabled';

export default function isDemoMode() {
  return isConfigEnabled(import.meta.env.VITE_RUN_IN_DEMO_MODE);
}
